import DocumentEditPage, { DocumentEditConfig } from 'src/document-editor/edit/DocumentEditPage';

const config: DocumentEditConfig = {
  pageType: 'data-export-edit',
  title: 'Data export',
  documentTypePath: 'data-exports',
  documentLabel: 'data export',
};

export default function DataExportEditPage() {
  return <DocumentEditPage config={config} />;
}
